import { z } from 'zod';

import { ZodAmount } from '@Common/types/Amount';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodDividendEvent = z.object({
  id: z.number(),
  instrument_id: z.number(),
  execution_date: z.string().datetime(),
  payable_date: z.string().datetime(),
  cash_amount_per_share: ZodAmount,
});
export type DividendEvent = z.infer<typeof ZodDividendEvent>;

export const ZodProfileDividendEvent = z.object({
  ...ZodDividendEvent.shape,
  applicable_shares: ZodTrimmedString,
  total_cash_amount: ZodAmount,
});

export type ProfileDividendEvent = z.infer<typeof ZodProfileDividendEvent>;

export const ZodInstrumentDividendEvent = ZodDividendEvent;
export type InstrumentDividendEvent = z.infer<typeof ZodInstrumentDividendEvent>;
